export default class JobseekerEducationsTemp {
    constructor(
        public qualification ?: string,
        public qualification_sub_category?:string,
        public course ?: string,
        public specialization  ?: string,
        public specialization_sub_category?:string,
        public institute_name  ?: string,
        public course_type  ?: string,
        public passing_year  ?: string,
        public grading_system  ?: string,
        public percentage  ?: string,
        public board  ?: string,
        public medium  ?: string,
        public jobseeker_id?: number,
        public provider?: string
    ){

    }
}